define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/UserContext"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, UserContext) {
    "use strict";
    var DnsList = /** @class */ (function () {
        function DnsList() {
            this.filterByAny = ko.observable('');
            this.canExport = UserContext.hasAccess('Admin,Dns.Export');
        }
        DnsList.prototype.init = function () {
            var self = this;
            $("#page-title").text("Hosted Zones");
            tools.ajaxGet({
                url: '/Dns/GetDnsListLookupData',
                success: function (data) {
                    if (data.Success) {
                        self.dnsLookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initGrid(self.dnsLookupLists.GridStructures.DnsZoneStructure);
                    ko.applyBindings(self, document.getElementById('main-container'));
                    $('#contextLoader').hide();
                    $('#mainContext').show();
                }
            });
        };
        DnsList.prototype.initGrid = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            //add actions column
            var actions = {
                field: "",
                width: "100px",
                template: function (dataItem) {
                    var html = '';
                    if (UserContext.hasAccess('Admin,Dns.View')) {
                        html += '<a class="btn btn-sm btn-yellow btn-edit" href="/Dns/Details?id=' + encodeURIComponent(dataItem.Id) + '&provider=' + dataItem.Provider + '"><i class="fa fa-edit "></i>&nbsp;View</a>';
                    }
                    return html;
                }
            };
            columns.push(actions);
            self.dnsTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/Dns/GetDnsZones",
                            type: "POST",
                            data: function () {
                                var data = {};
                                if (self.filterByAny()) {
                                    data.filterText = self.filterByAny();
                                }
                                return data;
                            },
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model
                    },
                    serverPaging: false,
                    serverFiltering: false,
                    serverSorting: false
                },
                gridOptions: {
                    toolbar: kendo.template($('#dns-toolbar-template').html()),
                    columns: columns,
                    resizable: true,
                    reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row",
                        extra: false
                    }
                },
                enableExport: {
                    entityName: 'DnsZone',
                    title: 'Hosted Zones',
                    enablePdf: false
                },
                allowBulkEdits: {
                    enabled: true,
                },
                gridId: 'tblDnsKendo',
                showPagerOnTop: false,
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.dnsTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.dnsTable.getGridData().dataSource.read();
            });
        };
        DnsList.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny('');
        };
        DnsList.prototype.exportTo = function () {
            var self = this;
            if (self.canExport) {
                self.dnsTable.exportTo();
            }
        };
        DnsList.prototype.showLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("DnsZone");
                dataLogs.open("Dns Zones logs");
                event.preventDefault();
            }
        };
        return DnsList;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith('/Dns/Index')) {
            log.log('Initialize Dns list');
            $(function () {
                (new DnsList()).init();
            });
        }
    }, 0);
    return DnsList;
});
//# sourceMappingURL=dnsList.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/dns/dnsList.js
// module id = 240
// module chunks = 2